import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-accessibility-support-article',
    template: `
        <ng-container i18n="@@support.articles.accessibility">
            <p>We provide a complete set of accessibility settings, so that absolutely everyone can learn touch typing.</p>
            <ol>
                <li>
                    <span>Go to <a routerLink="/account/preferences">My account - Preferences</a>.</span>
                </li>
                <li>
                    <span>
                        Either select one of the presets...
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/accessibilityPresets.png" />
                    </span>
                </li>
                <li>
                    <span>
                        ... or enable individual accessibility settings.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/accessibilitySettings.png" />
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class AccessibilitySupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
